import { findAncestor } from 'craft/utils';

/*
retrieves the closest parent RTE Node, if any
*/
export const getRTEAncestorFromTargetElement = (element: Element | null) => {
  return findAncestor(
    element as Element | null,
    `[data-rte-node=true][data-nid],[data-atomictext-node]`,
  );
};

/*
retrieves the closest parent active Slate instance, if any
*/
export const activeEditableAncestor = (element: Element | null) => {
  return findAncestor(
    element,
    `[data-slate-editor=true],[data-code-editor=true],[data-button-inline=true]`,
  );
};

/*
returns a tuple of [RTENode,TargetNode] from a target, by checking its parents
*/
export const createFocusTupleFromTargetElement = (element: Element | null): [string, string] => {
  const rteNodeAncestor = getRTEAncestorFromTargetElement(element);
  const targetedNode = findAncestor(element as Element | null, `[data-nid]`)?.getAttribute(
    'data-nid',
  ) as string;
  const focusedRte =
    (rteNodeAncestor?.getAttribute('data-nid') as string) ||
    (rteNodeAncestor?.getAttribute('data-atomictext-node') as string) ||
    '';

  return [focusedRte, targetedNode];
};
